import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
import { FormControl } from "react-bootstrap";
import axios from "axios";
import close from "../../images/cross-svgrepo-com.svg";
import { toast, ToastContainer } from "react-toastify";
import launc from "../../images/Campaign-01 1.png";
import { Form } from "react-bootstrap";
import NoIndex from "../NoIndex";
import { debounce } from "lodash";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
import { FixedSizeList as List } from "react-window";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import Loader from "./Loader";

const CreateCampaign = ({ userID }) => {
  const navigate = useNavigate();
  const [ImstantChecked, setImstantChecked] = useState(false);
  // templates assigning state.
  const [contacts, setContacts] = useState([]);
  const [headerText, setHeaderText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [footerText, setFooterText] = useState("");
  const [buttonText, setButtonText] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const [templateID, setTemplateID] = useState("");
  const [campPurpose, setCampPurpose] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [errorRepetition, setErrorRepetition] = useState("");
  const [repetition, setRepetition] = useState("");
  const [intervalUnit, setIntervalUnit] = useState("minutes");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [headerVariables, setHeaderVariables] = useState({});
  const [bodyVariables, setBodyVariables] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [dataToSend, setDataToSend] = useState([]);
  const [templateLanguage, setTemplateLanguage] = useState("");
  const [templateStatus, setTemplateStatus] = useState("");
  const [templateCategory, setTemplateCategory] = useState("");
  const [headerParams, setHeaderParams] = useState("");
  const [bodyParams, setBodyParams] = useState([]);
  const [imageFile, setImageFile] = useState([]);
  const [imageLink, setImageLink] = useState("");
  const [base64String, setBase64String] = useState("");
  const [imageName, setImageName] = useState("");
  const [imageCheck, setImageCheck] = useState(false);
  const [videoCheck, setVideoCheck] = useState(false);
  const [videoFile, setVideoFile] = useState([]);
  const [videoName, setVideoName] = useState("");
  const [base64VideoString, setBase64VideoString] = useState("");
  const [uploadedMediaUrl, setUploadedMediaUrl] = useState(null);
  const [audienceLoader, setAudienceLoader] = useState(false);
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [campaignType, setCampaignType] = useState("instant");
  const [CampaignNumber, setCampaignNumber] = useState("");
  const [groupName, setGroupName] = useState("");
  const [templateFormat, setTemplateFormat] = useState("");

  const [fileUrl, setFileUrl] = useState(null);
  const [documentLink, setDocumentLink] = useState("");
  const [documentFile, setDocumentFile] = useState("");
  const handleToggle = () => {
    const newValue = !ImstantChecked;
    setImstantChecked(newValue);
    console.log("Checkbox value:", newValue ? "Y" : "N");
  };

  const { baseUrl, config } = useContext(MyContext);
  const steps = [
    { title: "Schedule" },
    { title: "Audience" },
    { title: "Template" },
    { title: "Testing" },
    { title: "Save " },
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const progress = (currentStep / (steps.length - 1)) * 100;

  const getStatus = (index) => {
    if (index < currentStep) {
      return "Complete";
    } else if (index === currentStep) {
      return "In Progress";
    } else {
      return "Pending";
    }
  };

  const stepItems = [
    { title: "Schedule", status: "In progress" },
    { title: "Audience", status: "Pending" },
    { title: "Template", status: "Pending" },
    { title: "Testing", status: "Pending" },
    { title: "Launch Campaign", status: "Pending" },
  ];

  const handlePrevClick = () => {
    setCurrentStep((prevStep) => prevStep - 1);
    updateColors(currentStep - 1);
  };

  const handleNextClick = () => {
    setCurrentStep((prevStep) => prevStep + 1);
    updateColors(currentStep + 1);
  };

  const updateColors = (step) => {
    const counters = document.querySelectorAll(".circle");
    const progressBar = document.querySelector(".progress-bar");
    const progressIndicator = document.querySelector(".progress-indicator");

    counters.forEach((counter, index) => {
      if (index < step) {
        counter.classList.add("previous");
        counter.classList.remove("active");
      } else if (index === step) {
        counter.classList.add("active");
        counter.classList.remove("previous");
      } else {
        counter.classList.remove("previous", "active");
      }
    });

    progressBar.style.width = `${(step / (stepItems.length - 1)) * 100}%`;
    progressIndicator.style.width = `${
      ((step - 1) / (stepItems.length - 1)) * 100
    }%`;
  };
  const [stepNames, setstepNames] = useState([
    "Schedule",
    "Audience",
    "Template",
    "Testing",
    "Launch ",
  ]);
  const downloadSampleExcel = (template) => {
    const bodyComponent = template.components.find(
      (comp) => comp.type === "BODY"
    );

    const variableColumn =
      bodyComponent?.text
        ?.match(/\{\{(\d+)\}\}/g)
        ?.map((_, i) => `var${i + 1}`) || [];

    const mediaComponent = template.components.find(
      (comp) =>
        comp.type === "HEADER" &&
        (comp.format === "VIDEO" || comp.format === "IMAGE")
    );

    const isMediaTemplate = !!mediaComponent;

    const headers = ["mobileNumber"];
    // if (isMediaTemplate) headers.push("Media URL");
    headers.push(...variableColumn);

    const sampleData = [];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template Data");

    XLSX.writeFile(wb, `${template.name}_sample.xlsx`);
  };

  const clearMediaData = () => {
    setVideoFile([]);
    setVideoName("");
    setBase64VideoString("");
    setUploadedMediaUrl(null);
    setMediaUploadLoading(false);
    setVideoCheck(false);
  };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const originalName = file.name;
      const nameWithoutExt =
        originalName.substring(0, originalName.lastIndexOf(".")) ||
        originalName;
      console.log("Original Filename:", originalName);
      console.log("Filename without Extension:", nameWithoutExt);
      setTemplateFormat("IMAGE");
      setImageFile([file]);
      setImageName(nameWithoutExt);

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64String(reader.result);
        convertImage(nameWithoutExt, reader.result); // Pass the name and base64 string to the function
      };
      reader.readAsDataURL(file);
    }
  };

  const convertImage = async (imageName, base64String) => {
    try {
      const requestBody = {
        userid: userID,
        item_name: imageName,
        type: "IMG",
        image_data: base64String,
      };
      const response = await axios.post(
        "https://bumppy.in/Dhroom/api/v1/uploadItemImage.php",
        requestBody,
        config
      );
      console.log(response.data.image_url);
      if (response.data.status === "0") {
        setImageLink(response.data.image_url);
        console.log(imageLink);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const updateParams = () => {
    const updatedHeaderParams =
      Object.keys(headerVariables).length > 0
        ? Object.values(headerVariables)
        : [];
    const updatedBodyParams =
      Object.keys(bodyVariables).length > 0 ? Object.values(bodyVariables) : [];
    setHeaderParams(updatedHeaderParams);
    setBodyParams(updatedBodyParams);
  };

  const replaceVariablesHeader = (headerText) => {
    return headerText.replace(/\{\{(\d+)\}\}/g, (match, number) => {
      const variableIndex = parseInt(number) - 1;
      const variable = headerParams[variableIndex];
      return variable ? variable : ""; // Return ##1## if present, otherwise return nothing
    });
  };
  const replaceVariablesBody = (bodyText) => {
    return bodyText.replace(/\{\{(\d+)\}\}/g, (match, number) => {
      const variableIndex = parseInt(number) - 1;
      const variable = bodyParams[variableIndex];
      return variable ? variable : ""; 
    });
  };

  useEffect(() => {
    updateParams();
  }, [headerVariables, bodyVariables]);
  const getVendorAccounts = async (e) => {
    try {
      setLoading(true);
      var raw = JSON.stringify({
        userid: userID,
        phoneNumberId: SingleWhatsApp,
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers, // Using headers from config,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getTemplates`,
        requestOptions
      );

      const data = await res.json();

      if (data?.responseCode == "00") {
        setTemplates(data?.response.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };
  useEffect(() => {
    getVendorAccounts();
  }, [SingleWhatsApp]);

  const handleTemplateSelect = (e) => {
    clearMediaData();
    setDocumentFile("");
    setDocumentLink("");
    setVideoFile("");
    setVideoName("");
    setTemplateFormat("");
    const selectedValue = e.target.value;
    const template = templates.find((t) => t.name === selectedValue);

    if (!template) {
      // Handle case where template is not found
      console.error(`Template not found for value: ${selectedValue}`);
      resetTemplateStates();
      return;
    }

    setHeaderText("");
    setBodyText("");
    setFooterText("");
    setButtonText("");
    setImageFile([]);
   
    setSelectedTemplate(template);
    setTemplateName(template.name);
    setTemplateID(template.id);
    setTemplateLanguage(template.language);
    setTemplateStatus(template.status);
    setTemplateCategory(template.category);

    const initialHeaderVariables = {};
    const initialBodyVariables = {};

    if (template.components) {
      template.components.forEach((component) => {
        if (component.text) {
          const matches = component.text.match(/{{\d+}}/g);
          if (matches) {
            matches.forEach((match) => {
              if (component.type === "HEADER") {
                initialHeaderVariables[match] = "";
              } else {
                initialBodyVariables[match] = "";
              }
            });
          }
        }
      });

      setHeaderVariables(initialHeaderVariables);
      setBodyVariables(initialBodyVariables);

      template.components.forEach((component) => {
        switch (component.type) {
          case "HEADER":
           setTemplateFormat(component.format);

            setHeaderText(component.text || "");
            break;
          case "BODY":
            setBodyText(component.text || "");
            break;
          case "FOOTER":
            setFooterText(component.text || "");
            break;
          case "BUTTONS":
            if (component.buttons && Array.isArray(component.buttons)) {
              // Map over the buttons array to extract the text from each button
              setButtonText(component.buttons.map((button) => button.text));
            }
            break;
          default:
            break;
        }
      });
    }
  };

  const resetTemplateStates = () => {
    setSelectedTemplate(null);
    setHeaderText("");
    setBodyText("");
    setFooterText("");
    setButtonText("");
    setHeaderVariables({});
    setBodyVariables({});
    setTemplateName("");
    setTemplateID("");
    setTemplateLanguage("");
    setTemplateStatus("");
    setTemplateCategory("");
  };

  const handleHeaderInputChange = (variable, value) => {
    setHeaderVariables((prevState) => ({
      ...prevState,
      [variable]: value,
    }));
  };

  const handleBodyInputChange = (variable, value) => {
    setBodyVariables((prevState) => ({
      ...prevState,
      [variable]: value,
    }));
  };

  useEffect(() => {
    const updatedHeaderParams = Object.values(headerVariables);
    const updatedBodyParams = Object.values(bodyVariables);
    setHeaderParams(updatedHeaderParams);
    setBodyParams(updatedBodyParams);
  }, [headerVariables, bodyVariables]);

  const convertToMinutes = (value, unit) => {
    switch (unit) {
      case "minutes":
        return value;
      case "hours":
        return value * 60;
      case "days":
        return value * 60 * 24;
      default:
        return value;
    }
  };
  const formatDateTime = (date, time) => {
    return `${date} ${time}:00`; // Append seconds as 00
  };
  // Errors Toast for manage campaign
  const [errorName, setErrorName] = useState("");
  const [ErrorStartTime, setErrorStartTime] = useState();
  const [ErrorEndtime, setErrorEndTime] = useState();
  const [ErrorStartDate, setErrorStartDate] = useState();
  const [errorCampPurpose, setErrorCampPurpose] = useState("");
  const [ErrorEndDate, setErrorEndDate] = useState();
  const [ErrorRepetetion, setErrorRepetetion] = useState();
  const [ErrorTimeUnit, setErrorTimeUnit] = useState();
  const [ErrorAudience, setErrorAudience] = useState();
  const [ErrorTemplate, setErrorTemplate] = useState("");
  const updateSteps = (e) => {
    const targetId = e.target.id;
    setCurrentStep((prevStep) =>
      targetId === "next" ? prevStep + 1 : prevStep - 1
    );
  };
  const updateSteps1 = (e) => {
    if (!campaignName) {
      toast.error("Please Enter Campaign name.");
      setErrorName("Please Enter Campaign name.");
      return;
    } else if (!campPurpose) {
      toast.error("Please Select Purpose of Campaign.");
      setErrorCampPurpose("Please Select Purpose of Campaign.");
      return;
    } else if (!startDate) {
      toast.error("Please Select Start Date.");
      setErrorStartDate("Please Select Start Date.");
      return;
    } else if (!startTime) {
      toast.error("Please Select Start Time.");
      setErrorStartTime("Please Select Start Time.");
      return;
    }
    // If it's a Scheduled Campaign, check additional fields
    if (campaignType === "schedule") {
      if (!endDate) {
        toast.error("Please Select End Date.");
        setErrorEndDate("Please Select End Date.");
        return;
      } else if (!endTime) {
        toast.error("Please Select End Time.");
        setErrorEndTime("Please Select End Time.");
        return;
      } else if (!intervalUnit) {
        toast.error("Please Select Interval Time Unit.");
        setErrorTimeUnit("Please Select Interval Time Unit.");
        return;
      } else if (!repetition) {
        toast.error("Please Select Repetition of your Campaign.");
        setErrorRepetetion("Please Select Repetition of your Campaign.");
        return;
      }
    }
    // If validation passes, proceed to the next step
    const targetId = e.target.id;
    setCurrentStep(1);
  };
  const updateSteps2 = (e) => {
    if (selectedItems.length == 0) {
      toast.error("Please Select Audience for the Campaign.");
      setErrorAudience("Please Select Audience for the Campaign.");
      return;
    } else {
      const targetId = e.target.id;
      setCurrentStep((prevStep) =>
        targetId === "next" ? prevStep + 1 : prevStep - 1
      );
    }
  };
  const updateSteps3 = (e) => {
    if (!selectedTemplate) {
      toast.error("Please Select the Template.");
      setErrorTemplate("Please Select the Template.");
      return;
    }

    if (
      headerParams.length > 0 &&
      headerParams.every((param) => Object.keys(param).length === 0)
    ) {
      toast.error("Please provide Header Params.");
      setErrorTemplate("Please provide Header Params.");
      return;
    }
    if (imageCheck && imageFile.length === 0) {
      toast.error("Please upload image in header.");
      setErrorTemplate("Please upload image in header.");
      return;
    }
    if (videoCheck && videoFile.length === 0) {
      toast.error("Please upload video in header.");
      setErrorTemplate("Please upload video in header.");
      return;
    }

    if (
      bodyParams.length > 0 &&
      bodyParams.some((param) => Object.keys(param).length > 0)
    ) {
      // const isEmpty = bodyParams.some(
      //   (param) => Object.keys(param).length === 0
      // // );
      // if (isEmpty) {
      //   toast.error("Please provide Body Params.");
      //   setErrorTemplate("Please provide Body Params.");
      //   return;
      // }
    } else {
      toast.error("Please provide Body Params.");
      setErrorTemplate("Please provide Body Params.");
      return;
    }

    const targetId = e.target.id;
    setCurrentStep((prevStep) =>
      targetId === "next" ? prevStep + 1 : prevStep - 1
    );
  };
  // creating campaign form states
  const [campaignName, setcampaignName] = useState("");

  const [TestNumber, setTestNumber] = useState("");

  const [Channel, setChannel] = useState("");
  const [Checker, setChecker] = useState(false);

  const progressBarWidth = `${((currentStep - 1) / 4) * 100}%`;

  const [searchTerm, setSearchTerm] = useState("");
  const [searchSelectTerm, setsearchSelectTerm] = useState("");

  const [searchResults, setSearchResults] = useState([]);
  const [searchSelectResults, setsearchSelectResults] = useState([]);

  //  date changing value assigner

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  //  checker from toggling function
  function ChangeChecker() {
    if (Checker === false) {
      return setChecker(true);
    } else {
      return setChecker(false);
    }
  }
  function changeChannel() {
    if (Channel === "whatsApp") {
      return setChannel("sms");
    } else setChannel("whatsApp");
  }
  useEffect(() => {
    const newDataToSend = selectedItems.map((item) => ({
      member_id: item.id,
      name: item.contact_name,
      mobile: item.contact_number,
    }));
    setDataToSend(newDataToSend);
  }, [selectedItems]);
  // const NewCampaign = {
  //   userid: userID,
  //   campaignName: campaignName,
  //   purpose: campPurpose,
  //   startTime: formatDateTime(startDate, startTime),
  //   endTime: formatDateTime(endDate, endTime),
  //   interval: convertToMinutes(repetition, intervalUnit),
  //   channel: "Whatsapp",
  //   language_code: templateLanguage,
  //   members: dataToSend,
  //   template: templateName,
  //   template_category: templateCategory,
  //   templateMetaId: templateID,
  //   headerParams: uploadedMediaUrl ? [uploadedMediaUrl] : imageLink ? [imageLink] : headerParams,
  //   bodyParams: bodyParams,
  //   instant: campaignType === "instant" ? "Y" : "N"
  // };
  const NewCampaign = {
    userid: userID,
    campaignName: campaignName,
    startTime: formatDateTime(startDate, startTime),
    endTime: formatDateTime(endDate, endTime),
    interval: convertToMinutes(repetition, intervalUnit),
    channel: "Whatsapp",
    phoneNumberId: SingleWhatsApp,
    excelUrl: fileUrl,
    template: templateName,
    template_category: templateCategory,
    language_code: templateLanguage,
    templateMetaId: templateID,
    purpose: campPurpose,
    templateFormat: templateFormat,
    mediaUrl:
      uploadedMediaUrl && uploadedMediaUrl.length > 0
        ? uploadedMediaUrl
        : imageLink && imageLink.length > 0
        ? imageLink
        : headerParams && headerParams.length > 0
        ? headerParams
        : "",
    instant: campaignType === "instant" ? "Y" : "N",
  };

  function manageSend() {
    window.location.href = "/WhatsApp/Campaign";
  }

  function resetForm() {
    setcampaignName("");
    setCampPurpose("");
    setStartDate("");
    setStartTime("");
    setEndDate("");
    setEndTime("");
    setRepetition("");
    setIntervalUnit("minutes");
    setDataToSend([]);
    setSelectedItems([]);
    setTemplateName("");
    setTemplateID("");
    setHeaderParams("");
    setBodyParams([]);
    setSelectedItems([]);
    resetTemplateStates();
    setCurrentStep(0);
    setstepNames(["Schedule", "Audience", "Template", "Testing", "Launch "]);
  }

  const CreateNewCampaign = async (e) => {
    e.preventDefault(); // Prevent default form submission if applicable

    if (
      !isFormValid(
        campaignName,
        fileUrl,
        templateName,
        campPurpose,
        campaignType,
        startDate,
        startTime,
        CampaignNumber
      )
    ) {
      return; // Stop execution if validation fails
    }

    try {
      const raw = JSON.stringify(NewCampaign);

      const requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${baseUrl}/api/Campaign/v2.0/createCampaign`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      if (result.responseCode === "00") {
        toast.success(result.responseMessage + " 🚀");
        resetForm();
        navigate("/WhatsApp/Manage");
      } else {
        toast.error(result.responseMessage);
      }

      console.log(result);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to launch campaign");
    }
  };

  // getting contacts through api

  const getContacts = async (e) => {
    try {
      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Campaign/getContacts`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setContacts(data?.data);
      } else {
      }
    } catch (error) {}
  };
  useEffect(() => {
    getContacts();
  }, []);
  //geting Whatsapp number register
  const getWhatsappNumber = async (e) => {
    try {
      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setWhatsappNumbers(data?.response);
      } else {
      }
    } catch (error) {}
  };
  useEffect(() => {
    getWhatsappNumber();
  }, []);
  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.map((Num, i) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.map((Num, i) =>
        i === 0 ? setSingleWhatsApp(Num.phone_no_id) : ""
      );
    }
  }, [WhatsappNumbers]);

  const isFormValid = (
    campaignName,
    fileUrl,
    templateName,
    campPurpose,
    campaignType,
    startDate,
    startTime,
    CampaignNumber
  ) => {
    if (!campaignName) {
      toast.error("Campaign Name is required.");
      return false;
    }
    // if (!campPurpose) {
    //   toast.error("Campaign Purpose is required.");
    //   return false;
    // }
    if (!SingleWhatsApp) {
      toast.error("Please Select the Campaing Number.");
      return false;
    }
    if (!campaignType) {
      toast.error("Campaign Type is required.");
      return false;
    }
    if (campaignType === "schedule" && (!startDate || !startTime)) {
      toast.error("Please select a Campaign Start Date & Time.");
      return false;
    }
    if (!templateName) {
      toast.error("Please select a template for the campaign.");
      return false;
    }
    if (!fileUrl) {
      toast.error("Please select and upload the Excel file.");
      return false;
    }

    return true;
  };

  useEffect(() => {
    const filteredContacts = contacts?.filter((contact) =>
      contact?.contact_name?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredContacts);
  }, [searchTerm]);
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const selectedfilteredContacts = useMemo(() => {
    if (!searchSelectTerm) return selectedItems;

    return selectedItems.filter((contact) =>
      contact.contact_name
        ?.toLowerCase()
        .includes(searchSelectTerm.toLowerCase())
    );
  }, [searchSelectTerm, selectedItems]);

  // Update state with filtered results
  useEffect(() => {
    setsearchSelectResults(selectedfilteredContacts);
  }, [selectedfilteredContacts]);

  const handleSelectdSearch = (event) => {
    setsearchSelectTerm(event.target.value);
  };

  const clearSelectedSearch = () => {
    setsearchSelectTerm("");
  };

  const TestBody = {
    userid: userID,
    secret: "string",
    templateName: templateName,
    templateID: templateID,
    languageCode: templateLanguage,
    messaging_product: "whatsapp",
    contacts: [TestNumber],
    headerParams: uploadedMediaUrl
      ? [uploadedMediaUrl]
      : imageLink
      ? [imageLink]
      : headerParams,
    bodyParams: bodyParams,
    type: "template",
  };

  // const ExecuteTemplates = async (e) => {
  //   try {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     var raw = JSON.stringify(TestBody);

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     const res = await fetch(
  //       `${baseUrl}/api/Whatsapp/executeTemplate`,
  //       requestOptions
  //     );

  //     if (res.status === 200) {
  //       const data = await res.json();
  //       toast.success(data.responseMessage);
  //     } else {
  //       const data = await res.json();
  //       toast.error(data.responseMessage);
  //     }
  //   } catch (error) {}
  // };
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(false);
    setTimeout(() => setAnimate(true), 10);
  }, [headerText, bodyText, footerText, buttonText]);
  useEffect(() => {
    if (selectedTemplate && selectedTemplate.components) {
      // Check if any component has format 'IMAGE'
      const hasImageFormat = selectedTemplate.components.some(
        (component) => component.format === "IMAGE"
      );
      setImageCheck(hasImageFormat);

      // Check if any component has format 'VIDEO'
      const hasVideoFormat = selectedTemplate.components.some(
        (component) => component.format === "VIDEO"
      );
      setVideoCheck(hasVideoFormat);
    }
  }, [selectedTemplate]);
  // ################################################################################### *\

  const [searchName, setSearchName] = useState("");
  const [searchTag, setSearchTag] = useState("");
  const [isNameFilterActive, setIsNameFilterActive] = useState(false);
  const [isTagFilterActive, setIsTagFilterActive] = useState(false);
  const [selectedAudienceGroup, setSelectedAudienceGroup] = useState(null);
  const [audience, setAudience] = useState([]);
  const [loading, setLoading] = useState(false);
  const clearFilters = () => {
    setSearchName("");
    setSearchTag("");
    setIsNameFilterActive(false);
    setIsTagFilterActive(false);
  };
  // Fetch audience groups only once
  useEffect(() => {
    const fetchAudienceGroups = async () => {
      setLoading(true);
      try {
        const requestBody = {
          userid: userID,
        };
        const response = await axios.post(
          `${baseUrl}/api/LeadManagement/getAudienceGroup`,
          requestBody,
          config
        );
        if (response.data.responseCode === "00") {
          setAudience(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching audience:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAudienceGroups();
  }, [baseUrl, userID]);
  // Optimized debounced filtering
  const filterContacts = useCallback(
    debounce(
      (
        name,
        tag,
        nameActive,
        tagActive,
        audienceGroup,
        contactList,
        setFilteredContacts
      ) => {
        const contactsToFilter = audienceGroup
          ? audienceGroup.members || []
          : contactList || [];

        const filtered = contactsToFilter.filter((contact) => {
          const nameMatch = nameActive
            ? contact.contact_name?.toLowerCase().includes(name.toLowerCase())
            : true;
          const tagMatch = tagActive
            ? contact.tags?.some((t) =>
                t.trim().toLowerCase().includes(tag.trim().toLowerCase())
              )
            : true;
          return nameMatch && tagMatch;
        });

        setFilteredContacts(filtered);
      },
      500
    ),
    []
  );

  // Apply filtering and avoid unnecessary re-renders
  const filteredContacts = useMemo(() => {
    if (!isNameFilterActive && !isTagFilterActive)
      return selectedAudienceGroup?.members || contacts;
    return contacts.filter((contact) => {
      const nameMatch = isNameFilterActive
        ? contact.contact_name?.toLowerCase().includes(searchName.toLowerCase())
        : true;
      const tagMatch = isTagFilterActive
        ? contact.tags?.some((t) =>
            t.trim().toLowerCase().includes(searchTag.trim().toLowerCase())
          )
        : true;
      return nameMatch && tagMatch;
    });
  }, [
    searchName,
    searchTag,
    isNameFilterActive,
    isTagFilterActive,
    selectedAudienceGroup,
    contacts,
  ]);
  // Handle audience selection change
  const handleAudienceGroupChange = (e) => {
    const selectedId = e.target.value;
    const selectedGroup = audience.find((group) => group.id === selectedId);
    setSelectedAudienceGroup(selectedGroup);
  };

  // Handle selecting and deselecting items efficiently
  const handleToggleSelect = (item) => {
    setSelectedItems((prev) =>
      prev.some((selected) => selected.id === item.id)
        ? prev.filter((selected) => selected.id !== item.id)
        : [...prev, item]
    );
  };

  // Select/Deselect all items
  const handleSelectAll = () => {
    const newSelectedItems = filteredContacts.filter(
      (contact) => !selectedItems.some((item) => item.id === contact.id)
    );
    setSelectedItems((prev) => [...prev, ...newSelectedItems]);
  };

  const handleDeSelectAll = () => setSelectedItems([]);

  // Virtualized list rendering for large datasets
  const ContactItem = ({ index, style }) => {
    const contact = filteredContacts[index];
    const isSelected = selectedItems.some((item) => item.id === contact.id);
    return (
      <div
        style={style}
        onClick={() => handleToggleSelect(contact)}
        className=" cursor-pointer   "
      >
        <div className="bg-light p-1 ">
          {isSelected ? "✅" : "⬜"} {contact.contact_name} -{" "}
          {contact.contact_number}
        </div>
      </div>
    );
  };
  const handleDeselect = (item) => {
    const updatedItems = selectedItems.filter(
      (selectedItem) => selectedItem.id !== item.id
    );
    const remove = searchSelectResults.filter(
      (selectedItem) => selectedItem.id !== item.id
    );
    setSelectedItems(updatedItems);
    setsearchSelectResults(remove);
  };

  const createAudienceGroup = async () => {
    try {
      if (!selectedItems.length) {
        toast.error("Please select at least one contact.");
        return;
      }
      const transformedMembers = selectedItems.map((member) => ({
        id: member.id,
        contact_name: member.contact_name,
        contact_number: member.contact_number, // Ensure correct key name
      }));
      const requestBody = {
        userid: userID,
        audienceGroupName: groupName,
        members: transformedMembers,
      };
      const response = await axios.post(
        `${baseUrl}/api/LeadManagement/createAudienceGroup`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.data.message);
        // setShowModal(false);
      } else {
        toast.error(response.data.data.message);
      }
    } catch (error) {
      toast.error("Failed to create audience group");
    }
  };
  function VariableCounter(template) {
    let header = ["mobileNumber"];
    const bodyComponent = template.components.find(
      (comp) => comp.type === "BODY"
    );
    const variableColumn =
      bodyComponent?.text
        ?.match(/\{\{(\d+)\}\}/g)
        ?.map((_, i) => `var${i + 1}`) || [];
    const mediaComponent = template.components.find(
      (comp) =>
        comp.type === "HEADER" &&
        (comp.format === "VIDEO" || comp.format === "IMAGE")
    );
    const isMediaTemplate = !!mediaComponent;
    // if (isMediaTemplate) header.push("Media URL");
    header.push(...variableColumn);
    return header;
  }
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleFileCheck = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        toast.error("Failed to process file");
        reject("No file provided");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const firstRowData = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          range: 0,
        });
        if (firstRowData.length > 0) {
          resolve(firstRowData[0]); // Return the first row instead of setting state
        } else {
          toast.error("Uploaded file is empty or unreadable.");
          reject("Empty file");
        }
      };
      reader.readAsArrayBuffer(file);
    });
  };
  const arraysAreEqual = (arr1, arr2) => {
    if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
    return arr1.every((value, index) => value === arr2[index]);
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
      setIsProcessing(true); // Show loader
      try {
        const firstRow = await handleFileCheck(file);
        const expectedHeader = VariableCounter(selectedTemplate);
        if (!arraysAreEqual(expectedHeader, firstRow)) {
          toast.error("Uploaded file does not match expected format.");
          setIsProcessing(false);
          return;
        }
        await uploadFileToServer(file);
      } catch (error) {
        console.error("File validation error:", error);
      } finally {
        setIsProcessing(false); // Hide loader after processing
      }
    }
  };
  const uploadFileToServer = async (file) => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64String = reader.result.split(",")[1];
      const requestBody = {
        userid: userID,
        file_name: file.name.split(".")[0],
        file_data: base64String,
        type: "XLSX",
      };
      try {
        const response = await fetch(
          "https://bumppy.in/Dhroom/api/v1/uploadCampaignExcel.php",
          {
            method: "POST",
            headers: config.headers,
            body: JSON.stringify(requestBody),
          }
        );
        const result = await response.json();
        if (result.status === "0") {
          setFileUrl(result.file_url);
          toast.success("File uploaded successfully!");
        } else {
          toast.error("Upload failed. Try again.");
        }
      } catch (error) {
        console.error("Upload error:", error);
        toast.error("An error occurred during upload.");
      }
    };
  };
  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const originalName = file.name;
      const nameWithoutExt =
        originalName.substring(0, originalName.lastIndexOf(".")) ||
        originalName;

      console.log("Original Video Filename:", originalName);
      console.log("Filename without Extension:", nameWithoutExt);
      setTemplateFormat("VIDEO");
      setVideoFile([file]);
      setVideoName(nameWithoutExt);

      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result;
        setBase64VideoString(base64String);
        const mediaUrl = await uploadVideoAPI(base64String);
        if (mediaUrl) {
          setUploadedMediaUrl(mediaUrl);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadVideoAPI = async (fileData) => {
    if (!fileData) return;
    setMediaUploadLoading(true);

    const payload = {
      userid: userID,
      mediaData: fileData,
      mediaType: "video",
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/uploadMedia`,
        payload,
        config
      );

      if (response.status === 200 && response.data.responseCode === "00") {
        const mediaUrl = response.data.data.mediaId; // Extract media URL
        // toast.success("Video uploaded successfully");
        console.log("Video uploaded successfully, URL:", mediaUrl);
        return mediaUrl;
      } else {
        console.error("Failed to upload video", response);
      }
    } catch (error) {
      console.error("Error uploading video:", error);
    } finally {
      setMediaUploadLoading(false);
    }
    return null;
  };
  const videoUrl = useMemo(() => {
    return videoFile.length > 0 ? URL.createObjectURL(videoFile[0]) : null;
  }, [videoFile]);

  const handleDocumentUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ];

      if (!allowedTypes.includes(file.type)) {
        alert(
          "Please select a valid document file (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX)."
        );
        return;
      }

      if (file.size > 16 * 1024 * 1024) {
        alert("Document file size must be 16MB or less.");
        return;
      }
      setTemplateFormat("DOCUMENT");
      setDocumentFile(file); // Save file in state
      // Convert file to Base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64Data = reader.result.split(",")[1]; // Extract Base64 part
        uploadDocumentAPI(base64Data, file.type);
      };
      reader.onerror = (error) =>
        console.error("Error reading document file:", error);
    }
  };
  const uploadDocumentAPI = async (fileData, fileType) => {
    if (!fileData) return;
    setMediaUploadLoading(true);
    const payload = {
      userid: userID, // Replace with actual user ID
      mediaData: fileData, // Base64 of the file
      mediaType: "pdf",
      // fileType: "application/pdf",
    };
    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/uploadMedia`,
        payload,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success("Document uploaded successfully");
        setDocumentLink(response.data.data.mediaUrl);
        setUploadedMediaUrl(response.data.data.mediaId);
      } else {
        console.error("Failed to upload document", response);
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    } finally {
      setMediaUploadLoading(false);
    }
  };
  // Memoized document preview URL
  const documentPreviewUrl = useMemo(() => {
    if (documentFile) {
      return URL.createObjectURL(documentFile);
    }
    return null;
  }, [documentFile]);

  return (
    <>
      <div className="col-12 d-flex justify-content-center">
        <ToastContainer />
      </div>
      <div
        className="p-4 m-0 bg-white"
        style={{
          fontFamily: "Nunito,sans-serif",
        }}
      >
        <p className="CreateCampaign ps-4">Create Campaign</p>
        <div className="container-fluid px-0">
          <div className="row border p-2 m-4 rounded bg-light">
            <div className="col-12 col-lg-9">
              <div className="row">
                <div className="col-md-12" style={{ overflowY: "auto" }}>
                  <div className="campaignbox1 border ms-2">
                    <div className="step1 p-4">
                      <div>
                        <p className="campaignheading text-3-2">
                          Campaign Name
                          <p className="mb-0">
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                fontStyle: "italic",
                              }}
                            >
                              Choose a descriptive name that reflects your
                              target audience and campaign goals.
                            </span>
                          </p>
                        </p>
                        <div className="row">
                          <div className="mb-3 col-12 col-md-6">
                            <input
                              type="text"
                              className={`form-control ${
                                errorName ? "is-invalid" : ""
                              }`}
                              id="exampleFormControlInput1"
                              placeholder="Enter campaign name"
                              value={campaignName}
                              onChange={(e) => {
                                setcampaignName(e.target.value);
                                setErrorName("");
                              }}
                              maxLength="25"
                            />
                          </div>
                        </div>
                        {/* Campaign Purpose and WhatsApp Number */}
                        <div className="row">
                          {/* <div className="col-12 col-md-6">
                          <p className="campaignBoxName">
                            Campaign Purpose
                            <select
                              className={`form-select my-1 ${
                                errorCampPurpose ? "is-invalid" : ""
                              }`}
                              value={campPurpose}
                              onChange={(e) => {
                                setCampPurpose(e.target.value);
                                setErrorCampPurpose("");
                              }}
                            >
                              <option value="">Select Purpose</option>
                              <option value="1">Lead Generation</option>
                              <option value="2">Marketing & Awareness</option>
                            </select>
                          </p>
                        </div> */}
                          <div className="col-12 col-md-6">
                            <p className="campaignBoxName">
                              Campaigning Number
                              <select
                                className={`form-select my-1 ${
                                  errorCampPurpose ? "is-invalid" : ""
                                }`}
                                value={SingleWhatsApp}
                                onChange={(e) => {
                                  setSingleWhatsApp(e.target.value);
                                }}
                                disabled={!MultiplePhoneNumber}
                              >
                                <option value="">Select Number</option>
                                {WhatsappNumbers.map((num, index) => (
                                  <option key={index} value={num.phone_no_id}>
                                    {num.phone_no_id}-({num.phone_no})
                                  </option>
                                ))}
                              </select>
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column flex-md-row">
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheck1"
                            style={{ textAlign: "left" }}
                          >
                            <div>
                              <p className="campaignheading text-3-2">
                                Type of Campaign
                                <p className="mb-0">
                                  <span
                                    className=""
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    Instant campaigns send messages immediately,
                                    while scheduled campaigns deliver them at a
                                    set time.
                                  </span>
                                </p>
                              </p>
                            </div>
                          </label>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="campaignBoxName">
                                Campaign Type
                              </label>

                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="campaignType"
                                    id="instant"
                                    value="instant"
                                    checked={campaignType === "instant"}
                                    onChange={() => setCampaignType("instant")}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="instant"
                                  >
                                    Instant Campaign
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="campaignType"
                                    id="schedule"
                                    value="schedule"
                                    checked={campaignType === "schedule"}
                                    onChange={() => setCampaignType("schedule")}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="schedule"
                                  >
                                    Schedule It
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Schedule Campaign Section */}
                        {campaignType === "schedule" && (
                          <div className="row">
                            <div className="col-12">
                              <p className="campaignheading text-3-2">
                                Schedule Date and Time
                                <p className="mb-0">
                                  <span
                                    className=""
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    Set the start date and time for your
                                    campaign.
                                  </span>
                                </p>
                              </p>
                              <div className="row">
                                <div className="col-12 col-md-6 pe-0 pe-md-2">
                                  <p className="campaignBoxName">
                                    Start Date
                                    <input
                                      type="date"
                                      className="form-control my-1"
                                      value={startDate}
                                      onChange={(e) =>
                                        setStartDate(e.target.value)
                                      }
                                    />
                                  </p>
                                </div>
                                <div className="col-12 col-md-6 ps-0 ps-md-2">
                                  <p className="campaignBoxName">
                                    Start Time
                                    <input
                                      type="time"
                                      className="form-control my-1"
                                      value={startTime}
                                      onChange={(e) =>
                                        setStartTime(e.target.value)
                                      }
                                    />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="campaignbox1 border ms-4 col-12 pt-4 col-lg-9 mt-4 ps-4">
                  <div className="row justify-content-between col-12 col-md-12">
                    <div className="col-12 col-md-8">
                      <div className="select-template-menu">
                        <div className="template-menu">
                          <div>
                            <p className="campaignheading">
                              Select template
                              <p className="mb-0">
                                <span
                                  className=""
                                  style={{
                                    fontSize: "12px",
                                    color: "#666",
                                    fontStyle: "italic",
                                  }}
                                >
                                  Select the pre-approved template.
                                </span>
                              </p>
                            </p>

                            <div className="mb-5">
                              <Form.Select
                                onChange={handleTemplateSelect}
                                defaultValue=""
                              >
                                <option value="">Select a template</option>

                                {templates.map((template, index) =>
                                  template.status === "APPROVED" ? (
                                    <option key={index} value={template.name}>
                                      {template.name}
                                    </option>
                                  ) : (
                                    ""
                                  )
                                )}
                              </Form.Select>
                            </div>
                          </div>

                          <div>
                            {selectedTemplate &&
                              selectedTemplate.components && (
                                <div>
                                  {selectedTemplate.components.map(
                                    (component, idx) => (
                                      <div
                                        className="bg-white border-template  p-4 my-4"
                                        key={idx}
                                        style={{
                                          borderRadius: "1px solid #ccc",
                                        }}
                                      >
                                        <div className="campaignheading mb-2">
                                          {component.type}
                                        </div>
                                        {!component.buttons &&
                                          component.format !== "IMAGE" &&
                                          component.format !== "VIDEO" && (
                                            <p>
                                              <strong>Text:</strong>{" "}
                                              {component.text}
                                            </p>
                                          )}

                                        {component.format === "IMAGE" && (
                                          <div>
                                            <div>
                                              <label
                                                htmlFor={`image-upload-${idx}`}
                                              >
                                                Upload image in header :{" "}
                                              </label>
                                            </div>
                                            <input
                                              type="file"
                                              id={`image-upload-${idx}`}
                                              className="pt-2"
                                              accept="image/*"
                                              onChange={handleImageUpload}
                                            />
                                            {imageFile.length > 0 && (
                                              <div className="d-flex justify-content-center p-2 pt-4">
                                                <img
                                                  src={URL.createObjectURL(
                                                    imageFile[0]
                                                  )}
                                                  alt="Uploaded"
                                                  style={{ maxWidth: "90%" }}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        {component.format === "VIDEO" && (
                                          <div className="">
                                            <div>
                                              <label
                                                htmlFor={`video-upload-${idx}`}
                                              >
                                                Upload video in header:
                                              </label>
                                            </div>
                                            <input
                                              type="file"
                                              id={`video-upload-${idx}`}
                                              className="pt-2"
                                              accept="video/*"
                                              onChange={handleVideoUpload}
                                            />
                                            {mediaUploadLoading ? (
                                              <div className="d-flex justify-content-center my-4">
                                                <div className="loader"></div>
                                              </div>
                                            ) : videoUrl ? (
                                              <div className="d-flex justify-content-center p-2 pt-4">
                                                <video
                                                  src={videoUrl}
                                                  controls
                                                  style={{ maxWidth: "90%" }}
                                                />
                                              </div>
                                            ) : null}
                                            {/* {uploadedMediaUrl && (
        <p><strong>Video ID:</strong> {uploadedMediaUrl}</p>
      )} */}
                                          </div>
                                        )}
                                        {component.format === "DOCUMENT" && (
                                          <div>
                                            <div>
                                              <label
                                                htmlFor={`document-upload-${idx}`}
                                              >
                                                Upload document in header:
                                              </label>
                                            </div>
                                            <input
                                              type="file"
                                              id="document-upload"
                                              className="pt-2"
                                              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                              onChange={handleDocumentUpload}
                                            />
                                            {documentPreviewUrl && (
                                              <div className="d-flex justify-content-center p-2 pt-4">
                                                {documentFile.type ===
                                                "application/pdf" ? (
                                                  <iframe
                                                    src={documentPreviewUrl}
                                                    style={{
                                                      width: "100%",
                                                      height: "500px",
                                                      border: "none",
                                                    }}
                                                  />
                                                ) : (
                                                  <p>
                                                    Uploaded File:{" "}
                                                    <a
                                                      href={documentPreviewUrl}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      View Document
                                                    </a>
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                            {/* {uploadedMediaUrl && (
        <p><strong>Video ID:</strong> {uploadedMediaUrl}</p>
      )} */}
                                          </div>
                                        )}
                                        {component.text &&
                                          component.text.match(/{{\d+}}/g) &&
                                          component.text
                                            .match(/{{\d+}}/g)
                                            .map((variable, varIdx) => (
                                              <div
                                                className="d-flex py-2"
                                                key={varIdx}
                                              ></div>
                                            ))}
                                        {component.buttons &&
                                          component.buttons.length > 0 && (
                                            <div>
                                              {component.buttons.map(
                                                (button, bIdx) => (
                                                  <p key={bIdx}>
                                                    Button {bIdx + 1}.{" "}
                                                    <span className="text-3-2">
                                                      {button.text}
                                                    </span>
                                                  </p>
                                                )
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            {selectedTemplate && (
                              <>
                                <div className="input-group">
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="inputGroupFile04"
                                    aria-describedby="inputGroupFileAddon04"
                                    aria-label="Upload"
                                    onChange={handleFileUpload}
                                    accept=".xlsx"
                                  />
                                </div>
                                {isProcessing && (
                                  <Loader text="Checking and uploading file..." />
                                )}
                                <p className="text-danger">
                                  <b>*Ensure Country Code On Mobile Number</b>
                                </p>
                                <p
                                  className="text-primary mt-2 cursor-pointer"
                                  style={{ textDecoration: "underline" }}
                                  onClick={() =>
                                    downloadSampleExcel(selectedTemplate)
                                  }
                                >
                                  Download {selectedTemplate.name} Sample Excel
                                </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="navigation-buttons mt-3 pt-5 m-0 d-flex align-items-center">
                <button
                  className="blue-button ms-3"
                  id="launch"
                  style={{ width: "150px" }}
                  onClick={CreateNewCampaign}
                >
                  Save
                </button>
              </div>
            </div>
            {selectedTemplate && (
              <div className="col-12 col-lg-3 mt-4 mt-lg-0">
                <div className="mobile-card">
                  <div className="mobile-btn1"></div>
                  <div className="mobile-btn2"></div>
                  <div className="mobile-btn3"></div>
                  <div className="mobile-btn4"></div>
                  <div className="mobile-card-int">
                    <div className="bubble-container">
                      <div
                        className={`message-bubble ${
                          animate ? "message-bubble-animate" : ""
                        }`}
                      >
                        {uploadedMediaUrl ? (
                          <div
                            style={{
                              border: "2px solid #ccc",
                              borderRadius: "8px",
                              maxWidth: "90%",
                              height: "200px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            <span style={{ fontSize: "18px", color: "#888" }}>
                              {templateFormat === "DOCUMENT" ? (
                                <p>Document</p>
                              ) : templateFormat === "VIDEO" ? (
                                <p>Video</p>
                              ) : null}
                            </span>
                          </div>
                        ) : imageFile.length > 0 ? (
                          <img
                            src={URL.createObjectURL(imageFile[0])}
                            alt="Uploaded"
                            style={{ maxWidth: "90%" }}
                          />
                        ) : null}

                        {!uploadedMediaUrl && imageFile.length === 0 && (
                          <div className="header-text">
                            {replaceVariablesHeader(headerText) || ""}
                          </div>
                        )}

                        <div className="body-text py-1">
                          <div>{replaceVariablesBody(bodyText) || ""}</div>
                        </div>
                        <div className="footer-text">{footerText}</div>
                        <div className="footer-text text-end">05:27 PM</div>
                      </div>
                      {buttonText.length > 0 &&
                        buttonText.map((text, index) => (
                          <div
                            key={index}
                            className={`button-bubble ${
                              animate ? "button-bubble-animate" : ""
                            }`}
                          >
                            <div className="button-text text-success text-center mb-1">
                              {text}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="mobile-top">
                    <div className="mobile-camera">
                      <div className="mobile-int"></div>
                    </div>
                    <div className="mobile-speaker"></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
 
    </>
  );
};
export default CreateCampaign;
